import { render, staticRenderFns } from "./SimpleChannelItem.vue?vue&type=template&id=2d315d8e&scoped=true&"
import script from "./SimpleChannelItem.vue?vue&type=script&lang=js&"
export * from "./SimpleChannelItem.vue?vue&type=script&lang=js&"
import style0 from "./SimpleChannelItem.vue?vue&type=style&index=0&id=2d315d8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d315d8e",
  null
  
)

export default component.exports